<style scoped>
.modal-footer {
    display: block;
    text-align: center;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Locked</h2>
        </div>
        <div class="modal-body">
            <template v-if="!submitting">
                <p describedby-text>Please choose an action:</p>
                <button v-for="(lockAction, index) in lockActions" class="btn btn-primary my-2 mr-2" @click="submit(lockAction)" :disabled="submitting" :id="'lockActionBtn' + index">{{ lockAction.label }}</button>
            </template>
            <div v-if="submitting">
                <LoadingWheel :width="100" />
            </div>
        </div>
        <div class="modal-footer"></div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, SetupContext } from "vue";
import { LockAction } from "../elements/BaseElementDef";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { dialogSetup } from "@/lib/dialogMixin.3";
interface Props {
    submitFunction: (triggerKey: LockAction) => Promise<void>;
    lockActions: LockAction[];
}
export default defineComponent({
    props: ["submitFunction", "lockActions"],
    components: {
        LoadingWheel,
    },
    setup(props: Props, { emit }: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef);
        const submitting = ref(false);

        const submit = async (lockAction: LockAction) => {
            submitting.value = true;
            await props.submitFunction(lockAction);
            submitting.value = false;
            emit("close");
        };

        return {
            container: containerRef,
            submitting,
            submit,
        };
    },
});
</script>
